import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LabIdManager } from './labIdManager';
import { TokenManager } from './tokenManager';

@Injectable()
export class PaymentStatementsService {
  labId: string;

  constructor(private http: HttpClient, private datePipe: DatePipe) {
    this.labId = LabIdManager.labId;
  }

  getPaymentStatementsMetadata(statementType: string) {
    const httpHeaders = this.getHttpHeaders();
    const currentDate = new Date();
    const httpParams = this.getFromDateandToDate(currentDate);
    let url = `${environment.paymentStatementsApiEndpoint}/contractlabpaymentdocuments`;
    return this.http
      .get(`${url}/${statementType}/${this.labId}`, {
        headers: httpHeaders,
        params: httpParams,
      })
      .pipe(
        map((data: Array<any>) => {
          let filteredData = data
            .map((d) => {
              // assume the document content is for the month prior to the available date
              d.documentContentDate = new Date(d.availableDate);
              d.documentContentDate.setMonth(d.documentContentDate.getMonth() - 1);
              return d;
            })
            .sort((a, b) => {
              return b.documentContentDate.getTime() - a.documentContentDate.getTime();
            })
            .slice(0, 12);

          return filteredData;
        })
      );
  }

  getStatementPreSignedUrl(url: string) {
    const httpHeaders = new HttpHeaders().set(
      'Authorization',
      TokenManager.token.toString()
    );
    return this.http.get<{ href: string; type: string; rel: string }>(
      url,
      { headers: httpHeaders }
    );
  }

  getFromDateandToDate(date: Date) {
    const currentDate = new Date(date);
    const oneYearOldDate = currentDate.setFullYear(
      currentDate.getFullYear() - 1
    );
    const toDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    const fromDate = this.datePipe.transform(oneYearOldDate, 'yyyy-MM-dd');

    const httpParams = new HttpParams()
      .append('toDate', toDate)
      .append('fromDate', fromDate);
    return httpParams;
  }

  getHttpHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Authorization', TokenManager.token.toString())
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/payment-statements.service.ts